<template>
    <div class="paySuccess main center">
        <Icon type="md-checkmark-circle-outline" size="60" color="green"/>
        <h2 class="paySuccess-title">支付凭证已上传</h2>
        <p class="paySuccess-subtitle">确认收到款项后，会向联系人发送短信。信息可能存在延迟，敬请谅解。</p>
        <Button type="primary" @click="back">返回我的订单</Button>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data(){
        return {
            id:this.$route.params.id||'',
            type:this.$route.query.type||''
        }
    },
    computed:{
		...mapState({
			userInfo:state=>state.common.info,
            loginUserChannelUserType: state=>state.common.info.loginUserChannelUserType,
		})
	},
    mounted () {
    },
    methods: {
        back() {
            // if(this.loginUserChannelUserType!='SUB_NORMAL'){
            //     this.$router.push('/my/performance')
            // } else {
            //     this.$router.push('/my/policy')
            // }
            window.location.href = '/haierProduct.html#/my/customizedCCIC/order';
        }
    },
}
</script>
<style scoped lang="less">
.main{
    margin-top:95px;
    min-height:calc(100vh - 420px)
}
.paySuccess{
    padding:50px 20px;
    &-title{
        margin-top: 20px;
        font-size: 1.125em;
    }
    &-subtitle{
        color: red;
        font-size: 1em;
        margin-top: 10px;
        margin-bottom: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/successDadi.vue